import { IonAvatar } from '@ionic/react';
import { FC, ReactElement } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    avatarInitials: {
        background: 'var(--ion-color-step-100)',
        borderRadius: '50%',
        textTransform: 'uppercase',
        display: 'flex',
        width: 48,
        height: 48,
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 25,
        fontWeight: 500,
        color: 'var(--ion-color-medium)'
    }
});

export type ICommunityAvatar = {
    pictureUrl?: string;
    firstName?: string;
    lastName?: string;
    size?: number;
};

export const CommunityAvatar: FC<ICommunityAvatar> = ({ pictureUrl, firstName, lastName, size = 48 }) => {
    const classes = useStyles();

    const getAvatar = () => {
        let avatar: ReactElement;

        if (pictureUrl) {
            avatar = (
                <IonAvatar style={{width: size, height: size}}>
                    <img src={pictureUrl} alt="avatar" />
                </IonAvatar>
            );
        } else {
            avatar = (
                <div className={classes.avatarInitials}>
                    {firstName?.substring(0,1)}
                    {lastName?.substring(0,1)}
                </div>
            );
        }

        return avatar;
    };

    return getAvatar();
};
